import type { BillingRow, OrgBillingSummaryResponse, PeriodSummary } from "@/types/Billing";

export interface MarkedBillingRow extends BillingRow {
  company: boolean;
  memberName: string;
}

type PeriodKey = "lastMonth" | "thisMonth";

const zeroTotals = () => ({
  flexMinutes: 0, slotMinutes: 0, weekendFlexMinutes: 0, weekendSlotMinutes: 0,
  cancelledFlexMinutes: 0, cancelledWeekendMinutes: 0, gratisMinutes: 0,
});

const mergePeriod = (org: OrgBillingSummaryResponse, ownerMemberId: string, key: PeriodKey): PeriodSummary => {
  const first = org.perMember[0]?.summary[key];
  const rows: MarkedBillingRow[] = [];
  const totals = zeroTotals();
  for (const entry of org.perMember) {
    const p = entry.summary[key];
    for (const r of p.rows) rows.push({ ...r, company: entry.memberId !== ownerMemberId, memberName: entry.memberName });
    totals.flexMinutes += p.totals.flexMinutes;
    totals.slotMinutes += p.totals.slotMinutes;
    totals.weekendFlexMinutes += p.totals.weekendFlexMinutes;
    totals.weekendSlotMinutes += p.totals.weekendSlotMinutes;
    totals.cancelledFlexMinutes += p.totals.cancelledFlexMinutes;
    totals.cancelledWeekendMinutes += p.totals.cancelledWeekendMinutes;
    totals.gratisMinutes += p.totals.gratisMinutes;
  }
  return { label: first?.label ?? "", monthStart: first?.monthStart ?? "", monthEnd: first?.monthEnd ?? "", rows, totals };
};

/**
 * Flattens an org billing summary into combined Last/This-Month periods for the owner's dashboard,
 * tagging each row company (a fellow org member's) vs the owner's own, and summing period totals.
 */
export function flattenOrgBilling(org: OrgBillingSummaryResponse, ownerMemberId: string): { lastMonth: PeriodSummary; thisMonth: PeriodSummary } {
  return { lastMonth: mergePeriod(org, ownerMemberId, "lastMonth"), thisMonth: mergePeriod(org, ownerMemberId, "thisMonth") };
}
